import React from "react";
import calculatorJson from "../../../Configs/JSON/calculator.json";
import "../../../styles/Calculator/CalculateAge.less";
import InputSlider from "../../Common/InputSlider";

const CalculateAge = (props) => {
  // if(nextscrbutton="Scr1")
  return (
    <>
        <div className="agecomponent">
            <div className="agecomponentHeadPara">
              {/* <h3 className="agecomponentHeading">{calculatorJson["calculatorScr1aQuestion"]}</h3>    
              <p className="agecomponentPara">{calculatorJson["calculatorScr1bQuestion"]}</p> */}
            </div>
            <div className="ttl">{calculatorJson["calculatorScr1Question"]}</div>
            <div className="ageContainer">
              <InputSlider handleAgeVal={props.handleAgeVal} />
            </div>            
        </div>
    </>
  )
}

export default CalculateAge
